import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

@Injectable({
  providedIn: 'root'
})
export class ChatroomService {

  constructor(
    private readonly httpService: AmplifyHttpClient,
  ) { }

  public saveChatroom(request) {
    return this.httpService.post<any>(`api/chatroom/save-chatroom`, request).pipe(
      map(response => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      }),
    );
  }

  public getChatroom(request) {
    return this.httpService.post<any>(`api/chatroom/get-chatrooms`, request).pipe(
      map(response => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      }),
    );
  }

  public getChatroomUsers(request) {
    return this.httpService.post<any>(`api/chatroom/get-chatroom-users`, request).pipe(
      map(response => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      }),
    );
  }

  public addChatroomUser(request) {
    return this.httpService.post<any>(`api/chatroom/add-chatroom-users`, request).pipe(
      map(response => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      }),
    );
  }

  public removeChatroomUser(request) {
    return this.httpService.post<any>(`api/chatroom/remove-chatroom-users`, request).pipe(
      map(response => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      }),
    );
  }
}
